'use strict'
import {
	CLOSE_MODAL_SELECTED_SELECTION_DELETE,
	CLOSE_MODAL_SELECTED_SELECTION_EXPORT,
	CLOSE_MODAL_SELECTED_SELECTION_INFORMATION,
	CLOSE_MODAL_SELECTED_SELECTION_SAVE,
	OPEN_MODAL_SELECTED_SELECTION_DELETE,
	OPEN_MODAL_SELECTED_SELECTION_EXPORT,
	OPEN_MODAL_SELECTED_SELECTION_INFORMATION,
	OPEN_MODAL_SELECTED_SELECTION_SAVE,
	RECEIVE_ALL_SELECTIONS,
	RECEIVE_AND_SELECT_SELECTION,
	RECEIVE_DELETE_SELECTION,
	RECEIVE_FAVORITE_SELECTION,
	RECEIVE_FILTERS_VALUES,
	RECEIVE_REMOVE_FAVORITE_SELECTION,
	RECEIVE_SELECTED_EXPORT_SELECTIONS,
	RECEIVE_SELECTIONS_DETAIL_SITES,
	RECEIVE_SELECTIONS_EXPORT_HISTORY,
	RECEIVE_SELECTIONS_FILTERS,
	RECEIVE_SELECTIONS_KEY_FIGURES,
	RECEIVE_SELECTIONS_SITES,
	RECEIVE_SELECTIONS_STATUS,
	RECEIVE_SELECTIONS_WATERSHED,
	RESET_SELECTED_EXPORT_SELECTIONS,
	RESET_SELECTED_SELECTION,
	RESET_SELECTED_SELECTION_INFORMATION,
	RESET_SELECTION_INFORMATIONS,
	RESET_USER_SELECTION,
	SELECTED_SELECTION,
	SELECTED_SELECTION_INFORMATION
} from '../constants/SelectionConstants'
import DtoSelection from '../dto/DtoSelection'
import DtoSelectionSite from '../dto/DtoSelectionSite'
import DtoSelectionFilter from '../dto/DtoSelectionFilter'
import DtoFilter from '../dto/DtoFilter'
import { remove, uniqWith } from 'lodash'
import DtoSelectionDetailSite from '../../sites/dto/DtoSelectionDetailSite'
import DtoKeyFigures from '../../sites/dto/DtoKeyFigures'
import DtoSelectionExportHistory from '../dto/DtoSelectionExportHistory'
import DtoSelectionWatershed from '../dto/DtoSelectionWatershed'
import DtoSelectionStatus from '../dto/DtoSelectionStatus'

export const store = {
	selections: [],
	selectionSites: [],
	selectionFilters: [],
	filterValues: [],
	selectionDetailsSites: [],
	selectedSelection: undefined,
	selectionKeyFigures: [],
	selectionExportsHistory: [],
	selectionWatershed: [],
	selectionStatus: [],
	selectedSelectionInformation: undefined,
	modalSelectionInformation: false,
	modalSelectionDelete: false,
	modalSelectionExport: false,
	modalSelectionSave: false,
	selectedExportSelections: []
}

export function SelectionReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_ALL_SELECTIONS: {
			return Object.assign({}, state, {
				selections: uniqWith([].concat(action.selections.map(el => new DtoSelection(el)), state.selections), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case RECEIVE_SELECTIONS_SITES: {
			return Object.assign({}, state, {
				selectionSites: uniqWith([].concat(action.selectionSites.map(el => new DtoSelectionSite(el)), state.selectionSites), (a, b) => {
					return a.selectionId === b.selectionId && a.siteId === b.siteId
				})
			})
		}
		case RECEIVE_SELECTIONS_FILTERS: {
			return Object.assign({}, state, {
				selectionFilters: uniqWith([].concat(action.selectionFilters.map(el => new DtoSelectionFilter(el)), state.selectionFilters), (a, b) => {
					return a.filterId === b.filterId && a.selectionId === b.selectionId
				})
			})
		}
		case RECEIVE_FILTERS_VALUES: {
			return Object.assign({}, state, {
				filterValues: uniqWith([].concat(action.filterValues.map(el => new DtoFilter(el)), state.filterValues), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case RECEIVE_SELECTIONS_DETAIL_SITES: {
			return Object.assign({}, state, {
				selectionDetailsSites: uniqWith([].concat(action.selectionDetailsSites.map(el => new DtoSelectionDetailSite(el)), state.selectionDetailsSites), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case SELECTED_SELECTION: {
			return Object.assign({}, state, {
				selectedSelection: action.selectedSelection
			})
		}
		case RECEIVE_SELECTIONS_KEY_FIGURES: {
			return Object.assign({}, state, {
				selectionKeyFigures: uniqWith([].concat(action.selectionKeyFigures.map(el => new DtoKeyFigures(el)), state.selectionKeyFigures), (a, b) => {
					return a.id === b.id && a.typeId === b.typeId
				})
			})
		}
		case RECEIVE_SELECTIONS_EXPORT_HISTORY: {
			return Object.assign({}, state, {
				selectionExportsHistory: uniqWith([].concat(action.selectionExportsHistory.map(el => new DtoSelectionExportHistory(el)), state.selectionExportsHistory), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case RECEIVE_SELECTIONS_WATERSHED: {
			return Object.assign({}, state, {
				selectionWatershed: uniqWith([].concat(action.selectionWatershed.map(el => new DtoSelectionWatershed(el)), state.selectionWatershed), (a, b) => {
					return a.selectionId === b.selectionId && a.watershedId === b.watershedId
				})
			})
		}
		case RECEIVE_SELECTIONS_STATUS: {
			return Object.assign({}, state, {
				selectionStatus: action.selectionStatus.map(el => new DtoSelectionStatus(el))
			})
		}
		case RECEIVE_SELECTED_EXPORT_SELECTIONS: {
			return Object.assign({}, state, {
				selectedExportSelections: action.selectedExportSelections
			})
		}
		case RESET_SELECTED_EXPORT_SELECTIONS: {
			return Object.assign({}, state, {
				selectedExportSelections: []
			})
		}
		case RECEIVE_DELETE_SELECTION: {
			const selectionId = action.selectionId
			const selections = state.selections.map((o) => {
				if (o.id === selectionId) {
					return Object.assign({}, o, {
						close: true
					})
				}
				return o
			})
			return Object.assign({}, state, {
				selections: selections
			})
		}
		case RECEIVE_FAVORITE_SELECTION: {
			const selectionId = action.selectionId
			const copySelection = state.selections.slice()
			const selections = copySelection.map((o) => {
				if (o.id === selectionId) {
					return Object.assign({}, o, {
						favorite: true
					})
				}
				return o
			})
			return {
				...state,
				selections: selections
			}
		}
		case RECEIVE_REMOVE_FAVORITE_SELECTION: {
			const selectionId = action.selectionId
			const copySelection = state.selections.slice()
			const selections = copySelection.map((o) => {
				if (o.id === selectionId) {
					return Object.assign({}, o, {
						favorite: false
					})
				}
				return o
			})
			return {
				...state,
				selections: selections
			}
		}
		case RESET_SELECTED_SELECTION: {
			return Object.assign({}, state, {
				selectedSelection: undefined
			})
		}
		case RESET_USER_SELECTION: {
			return Object.assign({}, state, store)
		}
		case RECEIVE_AND_SELECT_SELECTION: {
			const selection = new DtoSelection(Object.assign({}, action.selection))
			const selections = state.selections.slice()
			const i = selections.findIndex(s => s.id === selection.id)
			if (i === -1) {
				selections.push(selection)
			} else {
				selections[i] = selection
			}
			return Object.assign({}, {
				selections
			}, state)
		}
		case RESET_SELECTION_INFORMATIONS: {
			const selectionId = action.selection
			const copyOfSelectionSites = remove(state.selectionSites, (o) => {
				return o.selectionId === selectionId
			})
			const copyOfSelectionFilters = remove(state.selectionFilters, (o) => {
				return o.selectionId === selectionId
			})

			return {
				...state,
				selectionSites: copyOfSelectionSites,
				selectionFilters: copyOfSelectionFilters
			}
		}
		case SELECTED_SELECTION_INFORMATION : {
			return Object.assign({}, state, {
				selectedSelectionInformation: action.selectedSelectionInformation
			})
		}
		case RESET_SELECTED_SELECTION_INFORMATION : {
			return Object.assign({}, state, {
				selectedSelectionInformation: undefined,
				modalSelectionInformation: false,
				modalSelectionDelete: false
			})
		}
		case OPEN_MODAL_SELECTED_SELECTION_INFORMATION : {
			return Object.assign({}, state, {
				modalSelectionInformation: true,
				selectedSelectionInformation: action.selectedSelectionInformation
			})
		}
		case OPEN_MODAL_SELECTED_SELECTION_DELETE : {
			return Object.assign({}, state, {
				selectedSelectionInformation: action.selectedSelectionInformation,
				modalSelectionDelete: true
			})
		}
		case OPEN_MODAL_SELECTED_SELECTION_EXPORT: {
			return Object.assign({}, state, {
				modalSelectionExport: true,
				selectedSelectionInformation: action.selectedSelectionInformation
			})
		}
		case OPEN_MODAL_SELECTED_SELECTION_SAVE: {
			return Object.assign({}, state, {
				selectedSelectionInformation: action.selectedSelectionInformation,
				modalSelectionSave: true
			})
		}
		case CLOSE_MODAL_SELECTED_SELECTION_INFORMATION : {
			return Object.assign({}, state, {
				modalSelectionInformation: false,
				selectedSelectionInformation: undefined
			})
		}
		case CLOSE_MODAL_SELECTED_SELECTION_DELETE : {
			return Object.assign({}, state, {
				modalSelectionDelete: false,
				selectedSelectionInformation: undefined
			})
		}
		case CLOSE_MODAL_SELECTED_SELECTION_EXPORT : {
			return Object.assign({}, state, {
				modalSelectionExport: false,
				selectedSelectionInformation: undefined
			})
		}
		case CLOSE_MODAL_SELECTED_SELECTION_SAVE : {
			return Object.assign({}, state, {
				modalSelectionSave: false,
				selectedSelectionInformation: undefined
			})
		}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/reducers/SelectionReducer.js